// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l-header {
    padding: 3px;
    border: 1px solid #8080804d;
}
.l-whitewall-body-container .p-button.p-component {
    /* color: #ffffff70; */
}
.l-whitewall-body-container .p-inputtext {
    /* background: transparent;
    color: unset; */
}
`, "",{"version":3,"sources":["webpack://./lino_react/react/components/LinoToolbar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,2BAA2B;AAC/B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI;mBACe;AACnB","sourcesContent":[".l-header {\n    padding: 3px;\n    border: 1px solid #8080804d;\n}\n.l-whitewall-body-container .p-button.p-component {\n    /* color: #ffffff70; */\n}\n.l-whitewall-body-container .p-inputtext {\n    /* background: transparent;\n    color: unset; */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
